export const serviceTypeMap = {
  0: '课件制作',
  1: '课件制作（截图版）',
  2: '图片转 WORD',
  3: '方正转 WORD',
  4: '图片识别',
  5: '内容数字化',
  9: 'PDF 转 WORD',
  10: '学转教',
  11: 'WORD 转方正',
  12: '彩色图片改单黑',
  13: '单黑图片改专色',
  14: '教用辅助线改专色',
  15: '图片提高分辨率',
  16: 'WORD 转方正',
  17: '图片提高清晰度V2',
  18: 'WORD 转课件',
  19: 'JSON 转 PPT',
  24: 'PDF识别',
  25: 'PPT 转 希沃',
  30: 'AI编辑（解题）',
  31: 'AI校对',
}

export const statusTypeMap = {
  0: {
    text: '待开始',
    color: '#9fc5f8',
  },
  1: {
    text: '已关闭',
    color: '#ccc',
  },
  2: {
    text: '等待审核',
    color: '#9483c6',
  },
  3: {
    text: '审核未通过',
    color: '#cf2a27',
  },
  8: {
    text: '已完成',
    color: '#009e0f',
  },
}

// 服务类型
export const createOptionsOrigin = (allTypeValue = '') => [
  {
    value: allTypeValue,
    label: '全部类型',
  },
  {
    value: 0,
    label: '课件制作',
  },
  {
    value: 2,
    label: '图片转 WORD',
  },
  {
    value: 3,
    label: '方正转 WORD',
  },
  // {
  //   value: 4,
  //   label: '图片识别',
  //   isDebug: true,
  // },
  {
    value: 5,
    label: '内容数字化',
  },
  {
    value: 9,
    label: 'PDF 转 WORD',
    isDebug: true,
  },
  {
    value: 10,
    label: '学转教',
    isDebug: true,
  },
  {
    value: 16,
    label: 'WORD 转方正',
    isDebug: true,
  },
  {
    value: 18,
    label: 'WORD 转课件',
    isDebug: false,
  },
  {
    value: 24,
    label: 'PDF识别',
    isDebug: true,
  },
  {
    value: 25,
    label: 'PPT 转 希沃',
    isDebug: false,
  },
  {
    value: 30,
    label: 'AI编辑（解题）',
    isDebug: false,
  },
  {
    value: 31,
    label: 'AI校对',
    isDebug: false,
  },
]

export const statusOptions = [
  {
    value: '',
    label: '全部状态',
  },
  {
    value: 0,
    label: '未提交',
  },
  {
    value: 2,
    label: '审核中',
  },
  {
    value: 3,
    label: '审核未通过',
  },
  {
    value: 4,
    label: '制作中',
  },
  {
    value: 8,
    label: '已完成',
  },
  {
    value: 9,
    label: '已失败',
  },
]
